import React from "react";
import {Icon} from "@me8eon/icons";
import {EonUiTooltip} from "@eon-ui/eon-ui-components-react";
import styles from "./IconButton.module.scss"

type Props = {
    active: boolean;
    label?: string;
    icon: string;
    onClick: (e: React.MouseEvent) => void;
}

export const IconButtonComponent: React.FC<Props> = ({active, label, onClick, icon}) => {
    return (
        <button
            type="button"
            className={`${styles['button']}  ${active ? styles['button--active'] : ""}`}
            onClick={onClick}
            aria-label={label}
        >
            <Icon name={icon}/>
            {label && (
                <EonUiTooltip slot="tooltip" size="small" placement="top">
                    <p className={styles['tooltip']}>
                        {label}
                    </p>
                </EonUiTooltip>
            )}
        </button>
    )
}